import { StrictLocalizeFunction } from "./localization/localize";

/**
 * Utility function to convert a number of bytes into a localized string that
 * can be easily read. The is beneficial when producing error messages
 * regarding a document/image upload that exceeds the maximum file size.
 * @param bytes bytes amount to be formatted to string
 * @returns localize string formated to show bytes using best unit
 */

const BYTE_MULTIPLIER = 1024;

export const formatBytes = (
  bytes: number,
  strictLocalize: StrictLocalizeFunction
) => {
  const sizeLocalizeFunctions = [byte, kilobyte, megabyte, gigabyte];
  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(BYTE_MULTIPLIER));
  const clampedSizeIndex = Math.max(
    0,
    Math.min(sizeIndex, sizeLocalizeFunctions.length - 1)
  );

  return (
    Math.floor(bytes / Math.pow(BYTE_MULTIPLIER, clampedSizeIndex)) +
    (sizeLocalizeFunctions[clampedSizeIndex]?.(strictLocalize) ?? "")
  );
};

const byte = (strictLocalize: StrictLocalizeFunction): string =>
  strictLocalize({
    defaultMessage: "Bytes",
    description: { text: "computer memory byte" },
  });

const kilobyte = (strictLocalize: StrictLocalizeFunction): string =>
  strictLocalize({
    defaultMessage: "KB",
    description: { text: "computer memory kilobyte" },
  });

const megabyte = (strictLocalize: StrictLocalizeFunction): string =>
  strictLocalize({
    defaultMessage: "MB",
    description: { text: "computer memory megabyte" },
  });

const gigabyte = (strictLocalize: StrictLocalizeFunction): string =>
  strictLocalize({
    defaultMessage: "GB",
    description: { text: "computer memory gigabyte" },
  });
